import React from 'react';
import { FormattedText } from 'core/i18n';

export const CaptchaBrandingInfo = ({ active, text }) =>
    active ? (
        <div className="recaptcha-info">
            <FormattedText value={text} />
        </div>
    ) : null;
